export const CLIENTS = [
  { name: 'LAINSA', code: 1 },
  { name: 'APTOS GALDANA', code: 2 },
  { name: 'AUDAX', code: 5 },
  { name: 'EDEN', code: 6 },
  { name: 'RAYAS', code: 7 },
  { name: 'ESPIGAS', code: 8 },
  { name: 'PREMIUM', code: 10 },
  { name: 'JUBILADOS', code: 12 },
  { name: 'H. LOAR', code: 14 },
  { name: 'AGAMENON', code: 17 },
  { name: 'HOTEL MELIA', code: 20 },
  { name: 'MELIA PERSONAL', code: 22 },
  { name: 'BINIGAUS', code: 25 },
  { name: 'SKYLINE', code: 28 },
  { name: 'GRAN MELIA', code: 30 },
  { name: 'CAPRI', code: 32 },
  { name: 'ROCA', code: 35 },
  { name: 'CASA MIRANDA', code: 37 },
  { name: 'CARLOS III', code: 38 },
  { name: 'SOL PARK', code: 40 },
  { name: 'BEACH PARK', code: 42 },
  { name: 'PLAYA PARK', code: 44 },
  { name: 'VICOTRIA PLAYA', code: 45 },
  { name: 'PARKS', code: 46 },
  { name: 'LLEVAIX', code: 48 },
  { name: 'SANTANDRIA', code: 50 },
  { name: 'DIONI', code: 52 },
  { name: 'HOTEL 55', code: 55 },
  { name: 'BARCELO', code: 58 },
  { name: 'HOTEL GALDANA', code: 60 },
  { name: 'PORT CIUTADELLA', code: 65 },
  { name: 'HOSTEL MENORCA', code: 68 },
  { name: 'PALADIUM', code: 70 },
  { name: 'ISLA PARAISO', code: 72 },
  { name: 'ILUNION', code: 73 },
  { name: 'SOL ISLA', code: 75 },
  { name: 'SIESTAMAR', code: 76 },
  { name: 'SA MIRADA', code: 77 },
  { name: 'LA QUINTA', code: 82 },
  { name: 'MILANOS', code: 85 },
  { name: 'PINGUINOS', code: 87 },
  { name: 'NARANJOS', code: 88 },
  { name: 'ALUA SOUL', code: 90 },
  { name: 'ALUA ILLA DE MENORCA', code: 93 },
  { name: 'ALUA SUN MEDITERRANEO', code: 95 },
  { name: 'ALUA FAR', code: 97 },
  { name: 'FUNDAS', code: 99 },
  { name: 'MIRADOR DES PORT', code: 101 },
  { name: 'MESTRAL', code: 102 },
  { name: 'SA MIRADA', code: 103 },
  { name: 'MENORCA CLEANING', code: 104 },
  { name: 'MENORCA HOME', code: 105 },
  { name: 'JENI', code: 106 },
  { name: 'ALFONS III', code: 107 },
  { name: 'S STANCIA', code: 108 },
  { name: 'PEDRO LLUCH', code: 109 },
  { name: 'MEDITERRANI', code: 110 },
  { name: 'PORT MAHON', code: 111 },
  { name: 'PLAYA SOUL', code: 114 },
  { name: 'LLEVANT', code: 118 },
  { name: 'PUEBLO', code: 119 },
  { name: 'CALA BONA', code: 120 },
  { name: 'CALA N\' BLANES', code: 121 },
  { name: 'BLANC PALACE', code: 122 },
  { name: 'LAS YUCAS', code: 123 },
  { name: 'MASCARO', code: 124 },
  { name: 'BRISAS', code: 125 },
  { name: 'ALTA GALDANA', code: 126 },
  { name: 'PLAYAS GALDANA', code: 128 },
  { name: 'STO TOMAS', code: 130 },
  { name: 'SUR MENORCA', code: 133 }
];


